import React from 'react'
import me from 'asset/me-min.png'

import {Props, State} from './HomeModel'
import Cloud from './Cloud/CloudComponent'

export default class Home extends React.Component<Props, State> {
	render() {
		return (
			<div className='d-flex flex-fill stars'>
				<div className='twinkling'></div>
				<div className='clouds'></div>
				<div className='d-flex flex-fill justify-content-center align-items-end'>
					<Cloud id='thought-1' primaryText='UI Designer' secondaryText='(Bootstrap, CSS3)' arrow='arrow-right' />
					<Cloud id='thought-2' primaryText='Desktop App UI Dev' secondaryText='(ElectronJs)' arrow='arrow-right' />
					<Cloud id='thought-3' primaryText='Web App UI Dev' secondaryText='(ReactJs, AngularJs)' arrow='arrow-down' />
					<Cloud id='thought-4' primaryText='4 Years of Expertise' secondaryText='(TSPL, TCS)' arrow='arrow-left' />
					<img src={me} className='me' alt='me.png' />
				</div>
			</div>
		)
	}
}
